<h1>Scan Book Case History <button type="button" (click)="CloseModal()"
        class="btn btn-default float-right">Close</button>
</h1>
<div class="row" *ngIf="!dataLoaded"><i class="fa fa-spin fa-spinner"></i></div>
<div class="row" *ngIf="dataLoaded">
    <div class="col-sm-8 border-right">
        <form [formGroup]="scanBookCaseHistoryForm" (submit)="saveScanBookCaseHistory()">
            <div class="row">

                <div class="col-sm-6 mt-5">
                    <label class="form-label">Patient Name *</label>
                    <input type="text" formControlName="patient_name" class="form-control readOnly"
                        readonly="readonly" />
                    <div *ngIf="submitted && f.patient_name.errors" class="invalid-feedback">
                        <div *ngIf="f.patient_name.errors.required">Patient Name is required</div>
                    </div>
                </div>

                <div class="col-sm-6 mt-5">
                    <label class="form-label">Patient Age*</label>
                    <input type="number" formControlName="patient_age" class="form-control readOnly"
                        readonly="readonly" />
                    <div *ngIf="submitted && f.patient_age.errors" class="invalid-feedback">
                        <div *ngIf="f.patient_age.errors.required">Age is required</div>
                    </div>
                </div>
                <div class="col-sm-6 mt-5">
                    <label class="form-label">Gender*</label>
                    <mat-select placeholder="Gender" formControlName="gender" class="readOnly">
                        <mat-option value="Male">Male</mat-option>
                        <mat-option value="Female">Female</mat-option>
                    </mat-select>
                    <div *ngIf="submitted && f.gender.errors" class="invalid-feedback">
                        <div *ngIf="f.gender.errors.required">Gender is required</div>
                    </div>
                </div>

                <div class="col-sm-6 mt-5">
                    <label class="form-label">Scan Dentist</label>
                    <mat-select placeholder="Select Pro" class="readOnly" formControlName="scan_dentist_id">
                        <input class="mySearchInput readOnly" type="text">
                        <mat-option value="">Scan Dentist</mat-option>
                        <mat-option [value]="bd.id" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                    </mat-select>
                </div>

                <div class="col-sm-6 mt-5">
                    <label class="form-label">Date*</label>
                    <input type="date" formControlName="case_history_submission_date" class="form-control"
                        readonly="readOnly" />
                    <div *ngIf="submitted && f.case_history_submission_date.errors" class="invalid-feedback">
                        <div *ngIf="f.case_history_submission_date.errors.required">Booking Date is required</div>
                    </div>
                </div>

                <div class="col-sm-6 mt-5">
                </div>

                <div class="col-sm-6 mt-5">
                    <label class="form-label">Type of Patient*</label>
                    <div class="col-sm-6 mt-4">
                        <mat-radio-group aria-label="Select an option" formControlName="type_of_patient">
                            <mat-radio-button [value]="1">Local</mat-radio-button> &nbsp;&nbsp;
                            <mat-radio-button [value]="2">Overseas</mat-radio-button>
                        </mat-radio-group>
                        <div *ngIf="submitted && f.type_of_patient.errors" class="invalid-feedback">
                            <div *ngIf="f.type_of_patient.errors.required">Type of Patient is required</div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 mt-5" *ngIf="scanBookCaseHistoryForm.controls['type_of_patient'].value==2">
                    <label class="form-label">Duration of Stay in India*</label>
                    <input type="number" formControlName="no_of_days" placeholder="No of days" class="form-control"
                        min="1" />
                    <div *ngIf="submitted && f.no_of_days.errors" class="invalid-feedback">
                        <div *ngIf="f.no_of_days.errors.required">No of Days is required</div>
                    </div>
                </div>

                <div class="col-sm-6 mt-5">
                    <label class="form-label">Chief Complaint*</label>
                    <mat-select placeholder="Chief Complaint" (selectionChange)="showChifComplaintTestBox($event)"
                        formControlName="chif_complaint" multiple>
                        <mat-option [value]="1">Anterior Correction</mat-option>
                        <mat-option [value]="2">Posterior Correction</mat-option>
                        <mat-option [value]="3">Others</mat-option>
                    </mat-select>
                    <div *ngIf="submitted && f.chif_complaint.errors" class="invalid-feedback">
                        <div *ngIf="f.chif_complaint.errors.required">Chief Complaint is required</div>
                    </div>
                    <div *ngIf="(f.chif_complaint.value==0 || f.chif_complaint.value=='0') && invalidChifComplaint"
                        class="invalid-feedback">
                        <div>Chief Complaint is required</div>
                    </div>
                </div>

                <div class="col-sm-6 mt-5" *ngIf="showOtherChifComplaint">
                    <label class="form-label">Chief Complaint Other Description*</label>
                    <textarea class="form-control" formControlName="other_chif_complaint" rows="2"></textarea>
                    <div *ngIf="submitted && f.other_chif_complaint.errors" class="invalid-feedback">
                        <div *ngIf="f.other_chif_complaint.errors.required">Chief Complaint Other Description is
                            required</div>
                    </div>

                </div>

                <div class="col-sm-6 mt-5">
                    <label class="form-label">Treatment Goal & Specific Notes</label>
                    <textarea class="form-control" formControlName="specific_note" rows="2"></textarea>
                </div>

                <div class="col-sm-6 mt-5">
                    <label class="form-label">Clinical Condition*</label>
                    <mat-select placeholder="Clinical Condition"
                        (selectionChange)="showClinicalConditionTestBox($event)" formControlName="clinical_condition"
                        multiple>
                        <mat-option [value]="1">Crowding</mat-option>
                        <mat-option [value]="2">Spacing</mat-option>
                        <mat-option [value]="3">Deep Bite</mat-option>
                        <mat-option [value]="4">Open Bite</mat-option>
                        <mat-option [value]="5">Anterior Crossbite</mat-option>
                        <mat-option [value]="6">Posterior Crossbite</mat-option>
                        <mat-option [value]="7">Flared Teeth</mat-option>
                        <mat-option [value]="8">Uneven Smile</mat-option>
                        <mat-option [value]="9">Class 1</mat-option>
                        <mat-option [value]="10">Class 2 Div 1</mat-option>
                        <mat-option [value]="11">Class 2 Div 2</mat-option>
                        <mat-option [value]="12">Class 3</mat-option>
                        <mat-option [value]="13">Other</mat-option>
                    </mat-select>
                    <div *ngIf="submitted && f.clinical_condition.errors" class="invalid-feedback">
                        <div *ngIf="f.clinical_condition.errors.required">Clinical Condition is required</div>
                    </div>
                    <div *ngIf="(f.clinical_condition.value==0 || f.clinical_condition.value=='0') && invalidClinicalCondition"
                        class="invalid-feedback">
                        <div>Clinical Condition is required</div>
                    </div>
                </div>

                <div class="col-sm-6 mt-5" *ngIf="showClinicalCondition">
                    <label class="form-label">Clinical Condition Other Description*</label>
                    <textarea class="form-control" formControlName="other_clinical_condition" rows="2"></textarea>
                    <div *ngIf="submitted && f.other_clinical_condition.errors" class="invalid-feedback">
                        <div *ngIf="f.other_clinical_condition.errors.required">Clinical Condition Other Description is
                            required
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 mt-5">
                    <label class="form-label">Arches to be Treated*</label>
                    <div class="col-sm-6 mt-4">
                        <mat-radio-group aria-label="Select Arches to be Treated" formControlName="arches_treated">
                            <mat-radio-button [value]="1">Upper Only</mat-radio-button> &nbsp;&nbsp;
                            <mat-radio-button [value]="2">Lower Only</mat-radio-button> &nbsp;&nbsp;
                            <mat-radio-button [value]="3">Both</mat-radio-button>
                        </mat-radio-group>
                        <div *ngIf="submitted && f.arches_treated.errors" class="invalid-feedback">
                            <div *ngIf="f.arches_treated.errors.required">Arches to be Treated is required</div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 mt-5">
                    <label class="form-label">Clinical Findings</label>
                    <textarea class="form-control" formControlName="clinical_finding" rows="3"></textarea>
                </div>

            </div>
            <div class="card-footer mt-4" *ngIf="myrole == '1' || (myrole == '3' && isCMAccess == '1') || myrole == '11' ">
                <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                        class="fa fa-spin fa-spinner"></i> Submit</button>
            </div>
        </form>
    </div>

</div>